import React, { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import { MyDomain } from "../../App";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { Autocomplete, Paper } from "@mui/material";
import { styled } from "@mui/system";
import CloseImg from "../../Images/CloseImg.png";
import arrowleft from "../../Images/arrowleft.png";
import LottifileLoading from "../../LottifileLoading.json";
import Lottie from "lottie-react";
import DialogTitle from "@mui/material/DialogTitle";
//import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";
import { AppContext, useAppContext } from "../../AppContext";
import { Popper } from "@mui/material";

const StyledPaper = styled(Paper)({
  maxHeight: "400px", // Set maximum height for the dropdown
  overflowY: "auto", // Enable vertical scroll
});

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  "& .MuiPaper-root": {
    width:
      window.innerWidth <= 1920
        ? "90%"
        : window.innerWidth <= 2560
        ? "70%"
        : window.innerWidth <= 3840
        ? "60%"
        : "50%", // Full width minus 5% padding on each side
    margin: "0 auto", // Center the modal horizontally
    maxWidth: "none", // Disable the default max width
    borderRadius: 0,
  },
}));

export default function CheckOutPersonalInfoDeliveryBlock({
  onAction,
  OBJForCheckOutDeliveryDetails,
  setOBJForCheckOutDeliveryDetails,
}) {
  const { t, i18n } = useTranslation();
  const user = JSON.parse(localStorage.getItem("user"));

  const [Towns, setTowns] = useState([]);
  const [CheckTowns, setCheckTowns] = useState([]);
  const [Direction, setDirection] = useState("");
  const {
    setCheckIfHaveAddressToCouldClickBuy,
    CheckIfHaveAddressToCouldClickBuy,
  } = useAppContext();

  const GetTowns = () => {
    axios
      .get(`${MyDomain}Towns/GetAllTowns`) // Replace with your API endpoint
      .then((response) => {
        setCheckTowns(response.data);
        const newArray = response.data.map((item) => ({
          label: item.town,
          value: item.town,
        }));
        setTowns(newArray);
        console.log(response.data);
      })
      .catch((err) => {
        console.log(err.response.data);
        setError(err.response.data); // Handle any errors
      });
  };
  useEffect(() => {
    GetTowns();
  }, []); // Empty dependency array ensures this effect runs once on mount

  console.log(user?.phoneNumber);
  const parts = user?.phoneNumber.split(" ");
  // Save before space in new const
  const countryCode = parts[0]; // "+972"

  // Save after space in new const
  const localNumber = parts[1]; // "0527477128"
  console.log(parts);
  console.log(countryCode);
  console.log(localNumber);

  const [CountryPhoneNumbersErr, setCountryPhoneNumbersErr] = useState(false);
  const [CountryPhoneNumbers, setCountryPhoneNumbers] = useState({
    label: countryCode,
    value: countryCode,
  });

  const [ArrayCountryPhoneNumbers, setArrayCountryPhoneNumbers] = useState([
    { label: "+972", value: "+972" },
  ]);
  const [ErrNoAddress, setErrNoAddress] = useState(false);
  const [ErrNoAddressMsg, setErrNoAddressMsg] = useState("");

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  useEffect(() => {
    //handleClearSpecificItem();
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const history = useHistory();
  const [ChooseOrCreateAddress, setChooseOrCreateAddress] = useState(0);

  const [data, setData] = useState([]);
  const [ChoosingDeliveryAddress, setChoosingDeliveryAddress] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const GetAddresses = () => {
    const data = {
      UserId: user?.userId,
    };
    // Fetch data when the component mounts
    axios
      .post(`${MyDomain}Addresses/GetAddressesByUserId`, data) // Replace with your API endpoint
      .then((response) => {
        setData(response.data); // Store the data
        setLoading(false); // Set loading to false
        setSelectedUserId(String(response.data[0].choosing));
        // Find the object where id === choosing
        const result = response.data.find(
          (item) => item.id === parseInt(item.choosing, 10)
        ); // Convert choosing to a number
        console.log(result);
        setChoosingDeliveryAddress(result);
        setCheckIfHaveAddressToCouldClickBuy(true);
        console.log(result);
        setOBJForCheckOutDeliveryDetails(result);
        if (Object.keys(result).length > 0) {
          setErrNoAddress(false);
          setErrNoAddressMsg("");
          console.log("Object has values");
        } else {
        }
      })

      .catch((err) => {
        setErrNoAddress(true);
        setErrNoAddressMsg(t("profile.Pleasecreateaddress"));
        console.log("Object is empty");
        setCheckIfHaveAddressToCouldClickBuy(false);

        setError(err.response.data); // Handle any errors
        setLoading(false);
      });
  };

  console.log(ChoosingDeliveryAddress);

  useEffect(() => {
    GetAddresses();
  }, []); // Empty dependency array ensures this effect runs once on mount

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isDrawerOpenCountryNumber, setIsDrawerOpenCountryNumber] =
    useState(false);

  const [FirstName, setFirstName] = useState(user.firstName);
  const [FirstNameError, setFirstNameError] = useState(false);

  const [LastName, setLastName] = useState(user.lastName);
  const [LastNameError, setLastNameError] = useState(false);

  const [PhoneNumber, setPhoneNumber] = useState("");
  const [PhoneNumberError, setPhoneNumberError] = useState(false);

  const [PhoneNumberDataBase, setPhoneNumberDataBase] = useState("");

  const [City, setCity] = useState(null);
  const [CityError, setCityError] = useState(false);

  const [Street, setStreet] = useState("");
  const [StreetError, setStreetError] = useState(false);

  const [Building, setBuilding] = useState("");
  const [Apt, setApt] = useState("");
  const [ZIPCode, setZIPCode] = useState("");

  const [IdOfDeleteAddress, setIdOfDeleteAddress] = useState("");
  const [ChooseIDForEdit, setChooseIDForEdit] = useState(0);

  const TheDirection = [
    { label: "All Districts", value: "All Districts" },
    { label: "Northern District", value: "Northern District" },
    { label: "Southern District", value: "Southern District" },
    { label: "Jerusalem District", value: "Jerusalem District" },
    { label: "Southern Triangle", value: "Southern Triangle" },
    { label: "Northern Triangle", value: "Northern Triangle" },
    { label: "Haifa and Carmel region", value: "Haifa and Carmel region" },
  ];
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const DeleteAddress = async () => {
    const data = {
      id: IdOfDeleteAddress,
    };
    try {
      const response = await axios.delete(
        `${MyDomain}Addresses/DeleteAddress`,
        {
          data: { id: IdOfDeleteAddress },
        }
      );
      GetAddresses();
      setOpen1(false);
      //setMessage('Item deleted successfully');
    } catch (err) {
      console.log(err.response.data);
    }
  };
  const [UpdateFillAll, setUpdateFillAll] = React.useState(false);

  const [selectedUserId, setSelectedUserId] = React.useState(null);
  const handleSubmit = (userId, userUserId) => {
    setSelectedUserId((prev) => (prev === userId ? null : userId));
    const data = {
      UserId: userUserId,
      Choosing: String(userId),
    };
    axios
      .put(`${MyDomain}Addresses/UpdateAddressById`, data) // replace with your API URL
      .then((response) => {
        console.log(response.data);
        GetAddresses();
      })
      .catch((error) => {});
  };
  const UpdateAddressFunc = () => {
    if (
      FirstNameCreate === "" ||
      LastNameCreate === "" ||
      CountryPhoneNumberCreate === null ||
      PhoneNumberCreate === "" ||
      CityCreate === null ||
      // StreetCreate === "" ||
      // ZIPCodeCreate === "" ||
      DirectionCreate === ""
    ) {
      setUpdateFillAll(true);
      console.log("fill all");
      return;
    }
    const data = {
      Id: ChooseIDForEdit,
      UserId: user?.userId,
      FirstName: FirstNameCreate,
      LastName: LastNameCreate,
      Phonenumber: CountryPhoneNumberCreate?.value + " " + PhoneNumberCreate,
      City: CityCreate?.label,
      Street: StreetCreate,
      Building: BuildingCreate,
      Apartment: AptCreate,
      ZIPCode: ZIPCodeCreate,
      Direction: DirectionCreate,
    };
    console.log(data);
    axios
      .put(`${MyDomain}Addresses/UpdateAddress`, data) // replace with your API URL
      .then((response) => {
        console.log(response.data);
        GetAddresses();
        setUpdateFillAll(false);
      })
      .catch((err) => {
        console.log(err.response.data);
      });
  };
  const [open1, setOpen1] = useState(false);
  const [openCart, setOpenCart] = useState(false);
  const handleClickOpen = async () => {
    setOpenCart(true);
  };
  const handleClose = () => {
    setOpenCart(false);
  };

  const [hovered, setHovered] = useState(false);

  const handleMouseEnter = () => {
    setHovered(true);
  };

  const handleMouseLeave = () => {
    setHovered(false);
  };

  const [hovered2, setHovered2] = useState(false);

  const handleMouseEnter2 = () => {
    setHovered2(true);
  };

  const handleMouseLeave2 = () => {
    setHovered2(false);
  };

  const [FirstNameCreate, setFirstNameCreate] = useState("");
  const [LastNameCreate, setLastNameCreate] = useState("");
  const [CountryPhoneNumberCreate, setCountryPhoneNumberCreate] = useState({
    label: "+972",
    value: "+972",
  });
  const [PhoneNumberCreate, setPhoneNumberCreate] = useState("");
  const [CityCreate, setCityCreate] = useState(null);
  const [StreetCreate, setStreetCreate] = useState("");
  const [BuildingCreate, setBuildingCreate] = useState("");
  const [AptCreate, setAptCreate] = useState("");
  const [ZIPCodeCreate, setZIPCodeCreate] = useState("");
  const [DirectionCreate, setDirectionCreate] = useState("");

  const phoneRegex = /^\+\d{1,3}\s?\(.+\)$/; // e.g., +1 (USA), +91 (India)

  const handleChange = (event, newValue) => {
    setCountryPhoneNumbers(newValue);

    if (newValue && !phoneRegex.test(newValue.label)) {
      setCountryPhoneNumbersErr(true);
    } else {
      setCountryPhoneNumbersErr(false);
    }
  };
  const CreateNewAddress = () => {
    if (
      FirstNameCreate === "" ||
      LastNameCreate === "" ||
      CountryPhoneNumberCreate === null ||
      PhoneNumberCreate === "" ||
      CityCreate === null ||
      // StreetCreate === "" ||
      // ZIPCodeCreate === "" ||
      DirectionCreate === ""
    ) {
      setUpdateFillAll(true);

      console.log("fill all");
      return;
    }
    const data = {
      UserId: user?.userId,
      FirstName: FirstNameCreate,
      LastName: LastNameCreate,
      Phonenumber: CountryPhoneNumberCreate?.value + " " + PhoneNumberCreate,
      City: CityCreate?.label,
      Street: StreetCreate,
      Building: BuildingCreate,
      Apartment: AptCreate,
      ZIPCode: ZIPCodeCreate,
      Direction: DirectionCreate,
    };
    console.log(data);
    axios
      .post(`${MyDomain}Addresses/CreateAddress`, data) // Replace with your API endpoint
      .then((response) => {
        setFirstNameCreate("");
        setLastNameCreate("");
        setCountryPhoneNumberCreate(null);
        setPhoneNumberCreate("");
        setCityCreate(null);
        setStreetCreate("");
        setBuildingCreate("");
        setAptCreate("");
        setZIPCodeCreate("");
        setDirectionCreate("");
        console.log(response.data);
        GetAddresses();
        setChooseOrCreateAddress(0);
        setErrNoAddress(false);
        setErrNoAddressMsg("");
        setUpdateFillAll(false);
      })
      .catch((err) => {
        console.log(err.response.data);
      });
  };

  console.log(ChoosingDeliveryAddress);
  const CustomPopper = (props) => {
    return <Popper {...props} placement="top-start" />;
  };
  const CreateNewAddressFuncShow = () => {
    return (
      <>
        <div
          style={{
            width: windowWidth <= 1024 ? "90%" : "40%",
            paddingBottom: 40,
          }}
        >
          <div
            style={{
              direction: i18n.resolvedLanguage === "en" ? "" : "rtl",
            }}
          >
            <img
              src={arrowleft}
              //alt={title}
              style={{
                maxHeight: 40,
                maxWidth: 40,
                //objectFit: "contain",
                marginBottom: 20,
                cursor: "pointer",
                opacity: 0.5,
              }}
              onClick={() => {
                setFirstNameCreate("");
                setLastNameCreate("");
                setCountryPhoneNumberCreate(null);
                setPhoneNumberCreate("");
                setCityCreate(null);
                setStreetCreate("");
                setBuildingCreate("");
                setAptCreate("");
                setZIPCodeCreate("");
                setDirectionCreate("");
                setChooseOrCreateAddress(0);
              }}
            />
            <p>
              {ChooseIDForEdit === 0 ? (
                <a style={{ fontWeight: "bold" }}>
                  {t("profile.Addanewaddress")}
                </a>
              ) : (
                <>
                  <a>{t("profile.edit")}</a>
                </>
              )}
            </p>
          </div>
          <TextField
            id="standard-basic"
            label={`${t("profile.Firstname")}*`}
            variant="standard"
            style={{
              paddingBottom: 45,
              width: "100%",
              maxWidth: 500,
            }}
            InputLabelProps={{
              style: { opacity: 0.5, fontSize: "15px" },
            }}
            value={FirstNameCreate}
            onChange={(e) => setFirstNameCreate(e.target.value)}
            //error={FirstNameError} // Apply the error state to show red color
          />
          <TextField
            id="standard-basic"
            label={`${t("profile.Lastname")}*`}
            variant="standard"
            style={{
              paddingBottom: 45,
              width: "100%",
              maxWidth: 500,
            }}
            InputLabelProps={{
              style: { opacity: 0.5, fontSize: "15px" },
            }}
            value={LastNameCreate}
            onChange={(e) => setLastNameCreate(e.target.value)}
            //error={LastNameError} // Apply the error state to show red color
            //helperText={LastNameError ? "This field is required" : ""}
          />
          <div
            style={{
              display: "flex",
              width: "100%",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <div
              style={{
                display: "flex",
                width: "35%",
              }}
            >
              <Autocomplete
                sx={{ width: "100%" }}
                options={ArrayCountryPhoneNumbers}
                getOptionLabel={(option) => option.label}
                value={CountryPhoneNumberCreate}
                onFocus={() => setIsDrawerOpenCountryNumber(true)} // Open drawer on focus
                onBlur={() => setIsDrawerOpenCountryNumber(false)} // Close drawer on blur
                onChange={(event, newValue) =>
                  setCountryPhoneNumberCreate(newValue)
                }
                PaperComponent={(props) => <StyledPaper {...props} />}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={`${t("profile.Countrynumber")}*`}
                    variant="standard"
                    style={{
                      paddingBottom: 45,
                      width: "100%",
                      maxWidth: 500,
                    }}
                    InputLabelProps={{
                      style: { opacity: 0.5, fontSize: "15px" },
                    }}
                    //error={CountryPhoneNumbersErr} // Apply the error state to show red color
                  />
                )}
              />
            </div>
            <div style={{ display: "flex", width: "60%" }}>
              <TextField
                id="standard-basic"
                label={`${t("profile.Phone")}*`}
                variant="standard"
                style={{ paddingBottom: 45, width: "100%" }}
                InputLabelProps={{
                  style: { opacity: 0.5, fontSize: "15px" },
                }}
                InputProps={{
                  inputProps: {
                    inputMode: "numeric",
                    pattern: "[0-9]*",
                    style: {
                      // Remove arrows in all browsers
                      "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button":
                        {
                          WebkitAppearance: "none",
                          margin: 0,
                        },
                      MozAppearance: "textfield", // Firefox
                      appearance: "none", // Standard
                    },
                  },
                }}
                value={PhoneNumberCreate}
                onChange={(e) =>
                  setPhoneNumberCreate(e.target.value.replace(/[^0-9]/g, ""))
                } // Force numbers only
                //error={PhoneNumberError}
              />
            </div>
          </div>
          <Autocomplete
            PopperComponent={CustomPopper} // 👈 Add this line
            options={Towns}
            getOptionLabel={(option) => option.label}
            value={CityCreate}
            open={isDrawerOpen} // Controlled open state
            onOpen={() => setIsDrawerOpen(true)}
            onClose={() => setIsDrawerOpen(false)}
            onChange={(event, newValue) => {
              if (newValue && newValue.isCustomOption) {
                console.log("Custom town option selected");
              } else {
                setCityCreate(newValue);
                const foundObject = CheckTowns.find(
                  (obj) => obj.town === newValue?.value
                );
                console.log(foundObject?.direction);
                setDirectionCreate(foundObject?.direction);
              }

              setIsDrawerOpen(false); // Close when value is selected
            }}
            PaperComponent={(props) => <StyledPaper {...props} />}
            noOptionsText={
              <div
                style={{
                  cursor: "pointer",
                  color: "#1976d2",
                  padding: "8px 16px",
                }}
                onClick={(e) => {
                  e.stopPropagation(); // Prevent event bubbling
                  console.log("Don't find your town clicked");
                }}
              >
                Don't find your town? Click here
                {isDrawerOpen && ( // Only show when drawer is open
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    {TheDirection.map((item, index) => (
                      <div
                        key={index}
                        onClick={(e) => {
                          e.stopPropagation(); // Prevent event bubbling
                          setCityCreate({
                            label: item.label,
                            value: item.value,
                          });
                          setDirectionCreate(item.value);
                          setIsDrawerOpen(false); // Explicitly close
                        }}
                        style={{
                          color: "black",
                          cursor: "pointer",
                          backgroundColor:
                            hoveredIndex === index ? "#f0f0f0" : "transparent",
                          //padding: "8px",
                          borderRadius: "4px",
                          transition: "background-color 0.3s ease",
                        }}
                        onMouseEnter={() => setHoveredIndex(index)}
                        onMouseLeave={() => setHoveredIndex(null)}
                      >
                        <a style={{ fontSize: 14 }}>{item.label}</a>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            }
            renderInput={(params) => (
              <TextField
                {...params}
                label={`${t("profile.City")}*`}
                variant="standard"
                style={{
                  paddingBottom: 45,
                  width: "100%",
                  maxWidth: 500,
                }}
                InputLabelProps={{
                  style: { opacity: 0.5, fontSize: "15px" },
                }}
                //error={CityError}
              />
            )}
          />
          {/* <TextField
            id="standard-basic"
            label={`${t("profile.Street")}*`}
            variant="standard"
            style={{
              paddingBottom: 45,
              width: "100%",
              maxWidth: 500,
            }}
            InputLabelProps={{
              style: { opacity: 0.5, fontSize: "15px" }, // Apply opacity to the label
            }}
            value={StreetCreate} // Bind the state value to the TextField
            onChange={(e) => setStreetCreate(e.target.value)} // Update state on input change
            //error={StreetError} // Apply the error state to show red color
          /> */}
          {/* <div
            style={{
              flexDirection: "row",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <TextField
              id="standard-basic"
              label={t("profile.Building")}
              variant="standard"
              style={{
                paddingBottom: 45,
                width: "30%",
                maxWidth: 500,
              }}
              InputLabelProps={{
                style: { opacity: 0.5, fontSize: "15px" }, // Apply opacity to the label
              }}
              value={BuildingCreate} // Bind the state value to the TextField
              onChange={(e) => setBuildingCreate(e.target.value)} // Update state on input change
            />
            <TextField
              id="standard-basic"
              label={t("profile.Apt")}
              variant="standard"
              style={{
                paddingBottom: 45,
                width: "30%",
                maxWidth: 500,
              }}
              InputLabelProps={{
                style: { opacity: 0.5, fontSize: "15px" }, // Apply opacity to the label
              }}
              value={AptCreate} // Bind the state value to the TextField
              onChange={(e) => setAptCreate(e.target.value)} // Update state on input change
            />
            <TextField
              id="standard-basic"
              label={`${t("profile.ZIPCode")}*`}
              variant="standard"
              style={{
                paddingBottom: 45,
                width: "30%",
                maxWidth: 500,
              }}
              InputLabelProps={{
                style: { opacity: 0.5, fontSize: "15px" }, // Apply opacity to the label
              }}
              value={ZIPCodeCreate} // Bind the state value to the TextField
              onChange={(e) => setZIPCodeCreate(e.target.value)} // Update state on input change
            />
          </div> */}
          <div
            style={{
              direction: i18n.resolvedLanguage === "en" ? "" : "rtl",
            }}
          >
            <button
              style={{
                borderWidth: 0,
                backgroundColor: "white",
                border: "1px solid black",
                color: "black",
                marginTop: 45,
                height: 50,
                width: "25%",
                maxWidth: 150,
                minWidth: 120,
              }}
              onClick={() => {
                {
                  ChooseIDForEdit === 0
                    ? CreateNewAddress()
                    : UpdateAddressFunc();
                }
              }}
            >
              {t("profile.Save")}
            </button>
            {UpdateFillAll ? (
              <>
                <a style={{ fontSize: 14, color: "red" }}>
                  {t("profile.Pleasefillinallrequiredfields")}
                </a>
              </>
            ) : (
              <></>
            )}
          </div>
        </div>
      </>
    );
  };

  const UpdateAddressFuncShow = () => {
    return (
      <>
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            //justifyContent: "center",
            alignItems: "center",
          }}
        >
          {data.length !== 0 ? (
            <div
              style={{
                width: windowWidth <= 1024 ? "90%" : "40%",
              }}
            >
              {data.map((Address) => (
                <div key={Address.id} style={{ paddingBottom: 50 }}>
                  <div
                    style={{
                      justifyContent: "space-between",
                      width: "100%",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <a style={{ fontWeight: "500" }}>
                      {Address.firstName} {Address.lastName}
                    </a>
                    <div
                      onClick={() => {
                        handleSubmit(Address.id, Address.userId);
                        setChoosingDeliveryAddress(Address);
                      }}
                      aria-label="controlled"
                      style={{
                        width: 24,
                        height: 24,
                        border: "2px solid black",
                        borderRadius: "50%",
                        position: "relative",
                        cursor: "pointer",
                      }}
                    >
                      {String(Address.id) === String(selectedUserId) && (
                        <div
                          style={{
                            width: 12,
                            height: 12,
                            backgroundColor: "black",
                            borderRadius: "50%",
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                          }}
                        />
                      )}
                    </div>
                  </div>

                  {/* <div>
                    <a>
                      {Address.building}, {Address.apartment}, {Address.street}
                    </a>
                  </div> */}
                  <div>
                    {/* <a>
                      {Address.zipCode}, {Address.city}
                    </a> */}
                    <a>{Address.city}</a>
                  </div>
                  <div>
                    <a>
                      {t("profile.Phone")} {Address.phonenumber}
                    </a>
                  </div>
                  <div
                    style={{
                      marginTop: 20,
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <a
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        const parts = Address.phonenumber.split(" ");
                        // Save before space in new const
                        const countryCode = parts[0]; // "+972"
                        // Save after space in new const
                        const localNumber = parts[1]; // "0527477128"

                        setFirstNameCreate(Address.firstName);
                        setLastNameCreate(Address.lastName);
                        setPhoneNumberCreate(localNumber);
                        setStreetCreate(Address.street);
                        setBuildingCreate(Address.building);
                        setAptCreate(Address.apartment);
                        setCityCreate({
                          label: Address.city,
                          value: Address.city,
                        });
                        setDirectionCreate(Address.direction);
                        setZIPCodeCreate(Address.zipCode);
                        setCountryPhoneNumberCreate({
                          label: countryCode,
                          value: countryCode,
                        });
                        setChooseIDForEdit(Address.id);
                        setChoosingDeliveryAddress(Address);
                        setChooseOrCreateAddress(1);
                      }}
                    >
                      {t("profile.edit")}
                    </a>
                    {/* {Address.firstName} */}

                    {String(selectedUserId) === String(Address.id) ? (
                      <></>
                    ) : (
                      <div
                        onClick={() => {
                          setIdOfDeleteAddress(Address.id);
                          DeleteAddress(Address.id);
                          setOpen1(true);
                        }}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: "pointer",
                        }}
                      >
                        <img
                          src={CloseImg}
                          //alt={title}
                          style={{
                            maxHeight: 18,
                            maxWidth: 18,
                            objectFit: "contain",
                          }}
                        />
                      </div>
                    )}
                  </div>
                  <div
                    style={{
                      marginTop: 20,
                      border: "0.2px solid #f4f4f5",
                      width: "100%",
                    }}
                  ></div>
                </div>
              ))}
            </div>
          ) : (
            <div style={{ width: "40%", marginBottom: 20 }}>
              {t("profile.Emptylist")}
            </div>
          )}
          <div
            style={{
              display: "flex",
              alignItems: "flex-start",
              width: "40%",
              paddingBottom: 40,
              color: hovered2 ? "#6b21a8" : "black", // Change color on hover
            }}
          >
            <a
              style={{ cursor: "pointer", fontSize: 14, fontWeight: "bold" }}
              onClick={() => {
                setChooseOrCreateAddress(1);
                setChooseIDForEdit(0);
                setCity(null);
                setStreet("");
                setBuilding("");
                setApt("");
                setZIPCode("");
              }}
              onMouseEnter={handleMouseEnter2}
              onMouseLeave={handleMouseLeave2}
            >
              {t("profile.Addanewaddress")}
            </a>
          </div>
        </div>
      </>
    );
  };
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        //backgroundColor: "#f9a8d4",
        width: "50%",
      }}
    >
      <React.Fragment>
        {/* <Button variant="outlined" onClick={handleClickOpen}>
          Open dialog
        </Button> */}
        <BootstrapDialog
          onClose={handleClose}
          aria-labelledby="customized-dialog-title"
          open={openCart}
          //fullWidth
          maxWidth={false} // Disable Material-UI's default width settings
        >
          <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
            {t("profile.AddressBook")}
          </DialogTitle>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={(theme) => ({
              position: "absolute",
              right: 8,
              top: 8,
              color: theme.palette.grey[500],
            })}
          >
            <CloseIcon />
          </IconButton>

          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
            }}
          >
            <div
              style={{
                flexDirection: "row",
                justifyContent: "space-around",
                width: "100%",
                display: "flex",
              }}
            >
              {loading ? (
                <div
                  style={{
                    justifyContent: "center",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <Lottie
                    style={{ height: 40, width: 40 }}
                    animationData={LottifileLoading}
                  />
                </div>
              ) : (
                <>
                  {ChooseOrCreateAddress === 0 ? (
                    <>{UpdateAddressFuncShow()}</>
                  ) : (
                    <>{CreateNewAddressFuncShow()}</>
                  )}
                </>
              )}
            </div>
          </div>
        </BootstrapDialog>
      </React.Fragment>
      <a style={{ fontSize: 20, fontWeight: "bold", paddingBottom: 3 }}>
        {t("profile.Deliveryaddress")}
      </a>
      <div
        style={{
          paddingBottom: 80,
          display: "flex",
          width: "100%",
          flexDirection: "column",
        }}
      >
        {CheckIfHaveAddressToCouldClickBuy ? (
          <>
            <p style={{ margin: 0, fontSize: 14, paddingBottom: 3 }}>
              {ChoosingDeliveryAddress.firstName}{" "}
              {ChoosingDeliveryAddress.lastName}
            </p>
            {/* <p style={{ margin: 0, fontSize: 14, paddingBottom: 3 }}>
               {ChoosingDeliveryAddress.street}, {ChoosingDeliveryAddress.building}
               </p> */}
            <p style={{ margin: 0, fontSize: 14, paddingBottom: 3 }}>
              {ChoosingDeliveryAddress.city}
            </p>
            <p style={{ margin: 0, fontSize: 14, paddingBottom: 20 }}>
              {t("profile.Phone")} {ChoosingDeliveryAddress.phonenumber}
            </p>
          </>
        ) : (
          <div
            style={{
              paddingBottom: 10,
              display: "flex",
              flexDirection: "column",
              color: "red",
              fontSize: 14,
            }}
          >
            <a>{t("profile.Youdonothaveadeliveryaddress")}</a>
            <a>{t("profile.Pleaseaddadeliveryaddress")}</a>
          </div>
        )}

        <a
          style={{
            cursor: "pointer",
            fontSize: 18,
            color: hovered ? "#6b21a8" : "black", // Change color on hover
            fontWeight: "bold",
            // backgroundColor: setCheckIfHaveAddressToCouldClickBuy
            //   ? "red"
            //   : "green",

            border: CheckIfHaveAddressToCouldClickBuy
              ? "none"
              : "1px solid red",
            padding: CheckIfHaveAddressToCouldClickBuy ? 0 : 5,
          }}
          onClick={handleClickOpen}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          {t("profile.Changeaddress")}
        </a>
      </div>

      {/* <div
        style={{
          //backgroundColor: "#6ee7b7",
          justifyContent: "flex-end",
          display: "flex",
          paddingRight: windowWidth <= 1024 ? "0%" : "10%",
          position: "absolute",
          bottom: 0,
          right: 0,
          width: "100%",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            paddingLeft: i18n.resolvedLanguage === "en" ? 0 : 15,
          }}
        >
          <button
            style={{
              color: "white",
              backgroundColor: "#27272a",
              borderWidth: 0,
              height: 50,
              width: windowWidth <= 1024 ? "100%" : 150,
              opacity: ErrNoAddress === false ? 1 : 0.5, // Optional: make it look disabled
              cursor: ErrNoAddress === false ? "pointer" : "not-allowed",
            }}
            disabled={ErrNoAddress !== false}
            onClick={() => {
              onAction();
            }}
          >
            {t("profile.Next")}
          </button>
          {ErrNoAddress ? (
            <>
              <a style={{ fontSize: 14, color: "red" }}>{ErrNoAddressMsg}</a>
            </>
          ) : (
            <></>
          )}
        </div>
      </div> */}
    </div>
  );
}
